// extracted by mini-css-extract-plugin
export default {"wrapper":"BackgroundImage-module--wrapper--245e3","image":"BackgroundImage-module--image--2b3c3","content":"BackgroundImage-module--content--afdc4"};